import Header from '@components/Header';
import Loading from '@components/Loading';
import { PaymentErrorType } from '@models/error';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useUserCancel from './hooks/useUserCancel';

interface Params {
    type: PaymentErrorType;
    payload: string;
}

const UserPaymentCancelActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('errors');
    useUserCancel(params);
    return (
        <AppScreen>
            <Header title={t('userCancel.title')} />
            <Loading/>
        </AppScreen>
    );
};

export default UserPaymentCancelActivity;
